/*
* Pipeline Theme — Stoic Custom JS
*/

(function() {

  // ── Cart drawer vs. cookie banner ─────────────────────────────────────────
  // Shopify's customer privacy banner can sit over the mobile cart drawer
  // checkout button. While the cart drawer is open, hide only known cookie
  // consent surfaces so checkout remains reachable.
  (function() {
    var STYLE_ID = 'stoic-cart-cookie-guard-style';
    var ROOT_CLASS = 'stoic-cart-drawer-open';

    function installStyle() {
      if (document.getElementById(STYLE_ID)) return;
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = [
        'html.' + ROOT_CLASS + ' #shopify-pc__banner,',
        'html.' + ROOT_CLASS + ' .shopify-pc__banner,',
        'html.' + ROOT_CLASS + ' .shopify-pc__banner__dialog,',
        'html.' + ROOT_CLASS + ' .shopify-pc__banner__wrapper,',
        'html.' + ROOT_CLASS + ' .shopify-pc__prefs__dialog,',
        'html.' + ROOT_CLASS + ' [data-tracking-consent] .popup__inner {',
        '  opacity: 0 !important;',
        '  visibility: hidden !important;',
        '  pointer-events: none !important;',
        '  transform: translateY(120%) !important;',
        '}'
      ].join('\n');
      document.head.appendChild(style);
    }

    function drawerIsOpen(drawer) {
      return !!drawer && (
        drawer.classList.contains('drawer--visible') ||
        drawer.classList.contains('is-open') ||
        drawer.getAttribute('aria-hidden') === 'false'
      );
    }

    function updateState() {
      var drawer = document.getElementById('drawer-cart');
      document.documentElement.classList.toggle(ROOT_CLASS, drawerIsOpen(drawer));
    }

    function initCookieGuard() {
      installStyle();
      updateState();

      var drawer = document.getElementById('drawer-cart');
      if (drawer && window.MutationObserver) {
        new MutationObserver(updateState).observe(drawer, {
          attributes: true,
          attributeFilter: ['class', 'aria-hidden']
        });
      }

      document.addEventListener('click', function() {
        window.setTimeout(updateState, 40);
      });
      document.addEventListener('theme:cart:reload', function() {
        window.setTimeout(updateState, 40);
      });
      document.addEventListener('theme:cart:change', function() {
        window.setTimeout(updateState, 40);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCookieGuard);
    } else {
      initCookieGuard();
    }
  })();

  
  // ── Klaviyo "Added to Cart" tracking ─────────────────────────────────────────
  // Pipeline uses an AJAX cart drawer, so standard Klaviyo Shopify tracking
  // never sees add-to-cart events. We hook into theme:cart:change (fired after
  // every successful cart mutation) and push to Klaviyo manually.
  // Covers: main product form, cart drawer upsell, sticky buy strip, post-buy sheet.
  (function() {
    var _prevItems = null; // null = baseline not yet loaded from /cart.js

    function itemsToMap(items) {
      var map = {};
      (items || []).forEach(function(item) {
        map[item.variant_id] = (map[item.variant_id] || 0) + item.quantity;
      });
      return map;
    }

    function toAbsoluteUrl(url) {
      if (!url) return '';
      if (url.indexOf('//') === 0) return 'https:' + url;
      return url; // already absolute (https:// or http://)
    }

    function pushAddedToCart(item, cart) {
      var kl = window.klaviyo;
      if (!kl || typeof kl.push !== 'function') return;

      var itemNames = (cart.items || []).map(function(i) { return i.product_title; });
      var cartItems = (cart.items || []).map(function(i) {
        return {
          ProductID: i.product_id,
          SKU: i.sku,
          ProductName: i.product_title,
          Quantity: i.quantity,
          ItemPrice: (i.price / 100).toFixed(2),
          RowTotal: (i.line_price / 100).toFixed(2),
          ProductURL: 'https://stoicperformance.com' + i.url,
          ImageURL: toAbsoluteUrl(i.image),
          ProductCategories: i.product_type ? [i.product_type] : []
        };
      });

      kl.push(['track', 'Added to Cart', {
        '$value': parseFloat((item.price / 100).toFixed(2)),
        AddedItemProductName: item.product_title,
        AddedItemProductID: item.product_id,
        AddedItemSKU: item.sku,
        AddedItemCategories: item.product_type ? [item.product_type] : [],
        AddedItemImageURL: toAbsoluteUrl(item.image),
        AddedItemURL: 'https://stoicperformance.com' + item.url,
        AddedItemPrice: parseFloat((item.price / 100).toFixed(2)),
        AddedItemQuantity: 1,
        ItemNames: itemNames,
        CheckoutURL: 'https://stoicperformance.com/checkout',
        Items: cartItems
      }]);
    }

    // Seed baseline from current cart state on page load.
    // This ensures the FIRST add-to-cart on any page session is always tracked,
    // not silently discarded to establish a baseline.
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { _prevItems = itemsToMap(cart.items); })
      .catch(function() { _prevItems = {}; });

    document.addEventListener('theme:cart:change', function(e) {
      if (_prevItems === null) return; // cart.js baseline still loading
      var cart = e.detail && e.detail.cart;
      if (!cart || !cart.items) return;

      var newItems = itemsToMap(cart.items);
      cart.items.forEach(function(item) {
        var vid = item.variant_id;
        if ((newItems[vid] || 0) > (_prevItems[vid] || 0)) {
          pushAddedToCart(item, cart);
        }
      });
      _prevItems = newItems;
    });
  })();

  // ── Auto-open cart drawer after add ──────────────────────────────────────────
  // Pipeline does not open the cart drawer automatically after an AJAX add.
  // We listen to theme:cart:change and open the drawer when item count increases.
  (function() {
    var _lastCount = null; // null = not yet seeded from /cart.js

    // Seed from current cart so the FIRST add always triggers the open.
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { _lastCount = cart.item_count || 0; })
      .catch(function() { _lastCount = 0; });

    document.addEventListener('theme:cart:change', function(e) {
      if (_lastCount === null) return; // still loading baseline
      var cart = e.detail && e.detail.cart;
      if (!cart) return;
      var newCount = cart.item_count || 0;

      if (newCount > _lastCount) {
        var drawer = document.getElementById('drawer-cart');
        if (drawer && !drawer.classList.contains('drawer--visible')) {
          // Pre-load cart HTML before opening the drawer.
          // Pipeline's loadHTML() fetches /?section_id=api-cart-items async —
          // if we open the drawer immediately it shows the empty state while loading.
          // Dispatching theme:cart:reload first starts that fetch, then we open
          // after 500ms when the section render has had time to complete.
          document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          setTimeout(function() {
            if (!drawer.classList.contains('drawer--visible')) {
              drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
            }
          }, 500);
        }
      }

      _lastCount = newCount;
    });
  })();

  // ── Sequential upsell chain (Liquid → JS next-product order) ────────────────
  var UPSELL_NEXT = {
    'stoic-knee-sleeves-black-label': 'stoic-wrist-wraps',
    'stoic-wrist-wraps':              'stoic-socks',
    'stoic-socks':                    null,
    'compression-pants':              null,
    'stoic-lifting-straps':           null
  };

  // ── Pill variant selection ─────────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    var pill = e.target.closest('[data-upsell-pill]');
    if (!pill) return;
    var wrap = pill.closest('[data-stoic-upsell-wrap]');
    if (!wrap) return;

    // Deselect all pills, select this one
    wrap.querySelectorAll('[data-upsell-pill]').forEach(function(p) { p.classList.remove('is-selected'); });
    pill.classList.add('is-selected');

    // Update the Add button's variant ID and the displayed price
    var vid = pill.getAttribute('data-variant-id');
    var price = pill.getAttribute('data-variant-price');
    var addBtn = wrap.querySelector('[data-stoic-upsell-add]');
    if (addBtn) addBtn.setAttribute('data-variant', vid);
    var priceEl = wrap.querySelector('.stoic-upsell__price');
    if (priceEl && price) priceEl.textContent = price;
  });

  // ── Quick-add handler ──────────────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-stoic-upsell-add]');
    if (!btn) return;
    var variantId = btn.getAttribute('data-variant');
    if (!variantId) return;

    var wrap = btn.closest('[data-stoic-upsell-wrap]');
    var currentHandle = wrap ? wrap.getAttribute('data-upsell-handle') : null;

    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'id=' + variantId + '&quantity=1'
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      btn.textContent = 'Added ✓';
      // Fetch real cart totals so Pipeline can update the price display correctly
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      // Give Pipeline the real cart data — it uses total_price to update the subtotal
      document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
      // Reload line items
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      // After a short pause, load the next suggestion in the chain
      setTimeout(function() {
        loadNextUpsell(wrap, currentHandle);
      }, 600);
    })
    .catch(function() {
      btn.disabled = false;
      btn.textContent = 'Add';
    });
  });

  function loadNextUpsell(wrap, currentHandle) {
    if (!wrap || !currentHandle) return;
    var nextHandle = UPSELL_NEXT[currentHandle];
    if (!nextHandle) { wrap.style.display = 'none'; return; }

    fetch('/products/' + nextHandle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        if (!product.available) { wrap.style.display = 'none'; return; }
        renderNextUpsell(wrap, nextHandle, product);
      })
      .catch(function() { wrap.style.display = 'none'; });
  }

  function renderNextUpsell(wrap, handle, product) {
    var variants = product.variants.filter(function(v) { return v.available; });
    if (!variants.length) { wrap.style.display = 'none'; return; }

    var firstVariant = variants[0];
    var imgUrl = product.featured_image || (product.images && product.images[0]) || '';
    var price = (firstVariant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    var mode = product.variants.length === 1 ? 'add'
              : (product.variants.length <= 4 && product.options.length === 1) ? 'pills'
              : 'link';

    var pillsHTML = '';
    if (mode === 'pills') {
      pillsHTML = '<div class="stoic-upsell__pills">';
      product.variants.forEach(function(v, i) {
        var sel = i === 0 ? ' is-selected' : '';
        var dis = v.available ? '' : ' disabled';
        var vPrice = (v.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        pillsHTML += '<button class="stoic-upsell__pill' + sel + '"'
          + ' data-upsell-pill data-variant-id="' + v.id + '" data-variant-price="' + vPrice + '"' + dis + '>'
          + v.title + '</button>';
      });
      pillsHTML += '</div>';
    }

    var actionHTML = mode === 'link'
      ? '<a href="/products/' + handle + '" class="stoic-upsell__link">View →</a>'
      : '<button class="stoic-upsell__btn btn btn--primary btn--small" data-stoic-upsell-add data-variant="' + firstVariant.id + '">Add</button>';

    wrap.setAttribute('data-upsell-handle', handle);
    wrap.querySelector('.stoic-upsell__card').innerHTML =
      '<a href="/products/' + handle + '" class="stoic-upsell__img-link" tabindex="-1">'
        + '<img src="' + imgUrl + '" alt="' + product.title + '" width="72" height="72" loading="lazy">'
      + '</a>'
      + '<div class="stoic-upsell__info">'
        + '<p class="stoic-upsell__name">' + product.title + '</p>'
        + '<p class="stoic-upsell__price">' + price + '</p>'
        + pillsHTML
      + '</div>'
      + actionHTML;
  }

  // ── Cart page upsell — pill selection ─────────────────────────────────────
  document.addEventListener('click', function(e) {
    var pill = e.target.closest('[data-cp-pill]');
    if (!pill) return;
    var wrap = pill.closest('[data-upsell-handle]');
    pill.closest('.stoic-cp-upsell__pills').querySelectorAll('[data-cp-pill]').forEach(function(p) { p.classList.remove('is-selected'); });
    pill.classList.add('is-selected');
    var vid = pill.getAttribute('data-variant-id');
    var price = pill.getAttribute('data-variant-price');
    var btn = wrap && wrap.querySelector('[data-stoic-cp-add]');
    if (btn) { btn.setAttribute('data-variant', vid); btn.textContent = 'Add to Order \u2014 ' + price; }
    var priceEl = document.getElementById('stoic-cp-price');
    if (priceEl && price) priceEl.textContent = price;
  });

  // ── Cart page upsell — add to order ───────────────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-stoic-cp-add]');
    if (!btn) return;
    var vid = btn.getAttribute('data-variant');
    if (!vid) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'id=' + vid + '&quantity=1'
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      // Reload the page so line items + totals refresh properly
      window.location.reload();
    })
    .catch(function() {
      btn.disabled = false;
      btn.textContent = orig;
    });
  });

  // ── Cart page upsell — dismiss ─────────────────────────────────────────────
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-stoic-cp-dismiss]')) return;
    var block = document.getElementById('stoic-cp-upsell');
    if (block) {
      block.style.transition = 'opacity .2s';
      block.style.opacity = '0';
      setTimeout(function() { block.style.display = 'none'; }, 200);
    }
    try { sessionStorage.setItem('stoic_cp_dismissed', '1'); } catch(err) {}
  });

  // Hide if dismissed this session
  (function() {
    try {
      if (sessionStorage.getItem('stoic_cp_dismissed') === '1') {
        var block = document.getElementById('stoic-cp-upsell');
        if (block) block.style.display = 'none';
      }
    } catch(err) {}
  })();

  // ── Low stock urgency badge ────────────────────────────────────────────────
  (function() {
    if (!window.stoicInventory) return;
    var badge = document.getElementById('stoic-stock-badge');
    function updateBadge(vid) {
      if (!badge) return;
      var qty = window.stoicInventory[parseInt(vid)];
      if (qty !== undefined && qty > 0 && qty <= 5) {
        badge.textContent = 'Only ' + qty + ' left';
        badge.style.display = 'inline-block';
      } else {
        badge.style.display = 'none';
      }
    }
    // On variant change event
    document.addEventListener('theme:variant:change', function(e) {
      var vid = e.detail && e.detail.variant && e.detail.variant.id;
      if (vid) updateBadge(vid);
    });
    // Also check on URL param (handles page load with ?variant=)
    var initVid = new URLSearchParams(location.search).get('variant');
    if (initVid) updateBadge(initVid);
  })();

  // ── Sticky mobile buy strip ────────────────────────────────────────────────
  (function() {
    var strip = document.getElementById('stoic-sticky-buy');
    if (!strip) return;
    var mainBtn = document.querySelector('[data-add-to-cart]') || document.querySelector('.product-form__submit') || document.querySelector('button[name="add"]');
    if (!mainBtn) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        strip.style.transform = entry.isIntersecting ? 'translateY(100%)' : 'translateY(0)';
      });
    }, { threshold: 0.5 });
    observer.observe(mainBtn);

    // Mirror variant changes into sticky strip price + availability
    document.addEventListener('theme:variant:change', function(e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      var priceEl = strip.querySelector('[data-sticky-price]');
      if (priceEl && v.price) {
        var fmt = (v.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        priceEl.textContent = fmt;
      }
      var addBtn = strip.querySelector('[data-sticky-add]');
      if (addBtn) {
        addBtn.setAttribute('data-variant', v.id);
        addBtn.disabled = !v.available;
        // Sync text with main button after a tick (preorder app may update it slightly later)
        setTimeout(function() { syncStickyText(addBtn); }, 80);
      }
    });

    // Sync sticky button text with whatever the main button says (catches "BACKORDERED" etc)
    function syncStickyText(stickyBtn) {
      var mainTextEl = document.querySelector('[data-add-to-cart-text]');
      if (!mainTextEl) return;
      var txt = (mainTextEl.textContent || '').trim();
      if (!txt) return;
      // Shorten "Add to Cart" variants; keep "Sold Out" and "BACKORDERED" as-is
      stickyBtn.textContent = txt;
    }

    // Watch the main button text for changes (preorder app swaps it to "BACKORDERED")
    var mainTextEl = document.querySelector('[data-add-to-cart-text]');
    if (mainTextEl) {
      var textObserver = new MutationObserver(function() {
        var addBtn = strip.querySelector('[data-sticky-add]');
        if (addBtn && !addBtn.disabled) syncStickyText(addBtn);
      });
      textObserver.observe(mainTextEl, { childList: true, subtree: true, characterData: true });
    }

    // Sticky add handler
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-sticky-add]');
      if (!btn) return;
      var vid = btn.getAttribute('data-variant');
      if (!vid) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'id=' + vid + '&quantity=1'
      })
      .then(function(r) { return r.json(); })
      .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
      .then(function(cart) {
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
        setTimeout(function() { btn.disabled = false; btn.textContent = 'Add to Cart'; }, 2000);
      })
      .catch(function() { btn.disabled = false; btn.textContent = 'Add to Cart'; });
    });
  })();

  // ── Hide "Fast 3-4 Day Shipping" badge on backordered variants ─────────────
  // The truck-icon shipping badge is a static product block, so it shows even
  // when the selected variant is on backorder ("BACKORDERED" + "Ships in approx
  // 8-12 weeks", injected by the Essential preorder app). That's contradictory.
  // Hide the badge whenever the current variant is backordered; restore it for
  // in-stock variants. Variant changes are app-driven and async, so we react to
  // theme:variant:change, re-check on a short pulse, and observe the cart form
  // for the app swapping in its preorder state. The badge lives outside the
  // cart form, so toggling it never feeds the observer.
  (function() {
    function shippingBadges() {
      return [].filter.call(document.querySelectorAll('.product__block__icon'), function(el) {
        var p = el.querySelector('p');
        return p && /day shipping|\d\s*[-–]\s*\d\s*day/i.test(p.textContent || '');
      });
    }
    function isBackordered() {
      var c = document.querySelector('.essential-preorder-container-active');
      if (c && c.offsetParent !== null) return true;
      return [].some.call(document.querySelectorAll('button, span, a'), function(el) {
        return (el.textContent || '').trim().toUpperCase() === 'BACKORDERED' && el.offsetParent !== null;
      });
    }
    function update() {
      var want = isBackordered() ? 'none' : '';
      shippingBadges().forEach(function(b) { if (b.style.display !== want) b.style.display = want; });
    }
    function pulse() { [0, 150, 500, 1200, 2200].forEach(function(d) { setTimeout(update, d); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pulse);
    else pulse();
    document.addEventListener('theme:variant:change', pulse);
    var target = document.querySelector('form[action*="/cart/add"]') || document.body;
    new MutationObserver(update).observe(target, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']
    });
  })();

  // ── Post-add upsell bottom sheet ──────────────────────────────────────────
  (function() {
    var sheet = document.getElementById('stoic-postbuy-sheet');
    var overlay = document.getElementById('stoic-postbuy-overlay');
    var card = document.getElementById('stoic-postbuy-card');
    var closeBtn = document.getElementById('stoic-postbuy-close');
    var nothanksBtn = document.getElementById('stoic-postbuy-nothanks');
    if (!sheet || !overlay || !card) return;

    // Only run on product pages
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) return;

    // Map current product handle → complementary product to suggest
    var POSTBUY_SUGGEST = {
      'stoic-knee-sleeves-black-label': 'stoic-wrist-wraps',
      'stoic-knee-sleeves-red-black':   'stoic-wrist-wraps',
      'stoic-knee-sleeves':             'stoic-wrist-wraps',
      'stoic-wrist-wraps':              'stoic-knee-sleeves-black-label',
      'stoic-lifting-belt':             'stoic-knee-sleeves-black-label',
      'stoic-lever-belt':               'stoic-knee-sleeves-black-label',
      'stoic-powerlifting-belt':        'stoic-knee-sleeves-black-label',
      'stoic-socks':                    'stoic-wrist-wraps',
      'compression-pants':              'stoic-socks',
    };

    var currentHandle = productSection.getAttribute('data-product-handle') || '';
    // Partial match for belt handles
    var suggestHandle = POSTBUY_SUGGEST[currentHandle];
    if (!suggestHandle) {
      for (var key in POSTBUY_SUGGEST) {
        if (currentHandle.indexOf(key) !== -1 || key.indexOf('belt') !== -1 && currentHandle.indexOf('belt') !== -1) {
          suggestHandle = POSTBUY_SUGGEST[key];
          break;
        }
      }
    }
    if (!suggestHandle) return; // No suggestion for this product

    var lastCartCount = -1;
    var sheetTimer = null;

    function dismissSheet() {
      sheet.style.transform = 'translateY(100%)';
      overlay.style.opacity = '0';
      setTimeout(function() {
        sheet.style.display = 'none';
        overlay.style.display = 'none';
        overlay.style.opacity = '';
      }, 300);
      clearTimeout(sheetTimer);
    }

    function showSheet(product, currentCartItems) {
      // Don't show if already in cart
      for (var i = 0; i < currentCartItems.length; i++) {
        if (currentCartItems[i].handle === product.handle) return;
      }
      var variants = product.variants.filter(function(v) { return v.available; });
      if (!variants.length) return;

      var firstVariant = variants[0];
      var imgUrl = product.featured_image || (product.images && product.images[0]) || '';
      var price = (firstVariant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      var mode = product.variants.length === 1 ? 'add'
                : (product.variants.length <= 4 && product.options.length === 1) ? 'pills'
                : 'link';

      var pillsHTML = '';
      if (mode === 'pills') {
        pillsHTML = '<div class="stoic-upsell__pills" style="margin-top:6px;">';
        product.variants.forEach(function(v, i) {
          var sel = i === 0 ? ' is-selected' : '';
          var dis = v.available ? '' : ' disabled';
          var vPrice = (v.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          pillsHTML += '<button class="stoic-upsell__pill' + sel + '" data-pb-pill'
            + ' data-variant-id="' + v.id + '" data-variant-price="' + vPrice + '"' + dis + '>'
            + v.title + '</button>';
        });
        pillsHTML += '</div>';
      }

      var actionHTML = mode === 'link'
        ? '<a href="/products/' + product.handle + '" class="stoic-upsell__link" style="flex-shrink:0">View →</a>'
        : '<button id="stoic-postbuy-add" data-variant="' + firstVariant.id + '" style="'
          + 'flex-shrink:0;background:#b84e24;color:#fff;border:none;border-radius:3px;'
          + 'font-size:.85rem;font-weight:700;padding:10px 20px;cursor:pointer;white-space:nowrap;'
          + '">Add</button>';

      card.innerHTML =
        '<a href="/products/' + product.handle + '" style="flex-shrink:0;">'
          + '<img src="' + imgUrl + '" alt="' + product.title + '" width="80" height="80" '
          + 'style="width:80px;height:80px;object-fit:cover;border-radius:6px;display:block;" loading="lazy">'
        + '</a>'
        + '<div style="flex:1;min-width:0;">'
          + '<p style="margin:0 0 2px;font-size:.85rem;font-weight:700;">' + product.title + '</p>'
          + '<p id="stoic-pb-price" style="margin:0;font-size:.8rem;opacity:.6;">' + price + '</p>'
          + pillsHTML
        + '</div>'
        + actionHTML;

      // Wire add button
      var addBtn = document.getElementById('stoic-postbuy-add');
      if (addBtn) {
        addBtn.addEventListener('click', function() {
          var vid = addBtn.getAttribute('data-variant');
          if (!vid) return;
          addBtn.disabled = true;
          addBtn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'id=' + vid + '&quantity=1'
          })
          .then(function(r) { return r.json(); })
          .then(function() { return fetch('/cart.js').then(function(r) { return r.json(); }); })
          .then(function(cart) {
            addBtn.textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true, detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
            setTimeout(dismissSheet, 800);
          })
          .catch(function() { addBtn.disabled = false; addBtn.textContent = 'Add'; });
        });
      }

      // Wire pill selection
      card.querySelectorAll('[data-pb-pill]').forEach(function(pill) {
        pill.addEventListener('click', function() {
          card.querySelectorAll('[data-pb-pill]').forEach(function(p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          var vid = pill.getAttribute('data-variant-id');
          var vPrice = pill.getAttribute('data-variant-price');
          if (addBtn) addBtn.setAttribute('data-variant', vid);
          var priceEl = document.getElementById('stoic-pb-price');
          if (priceEl && vPrice) priceEl.textContent = vPrice;
        });
      });

      // Show the sheet
      sheet.style.display = 'block';
      overlay.style.display = 'block';
      overlay.style.opacity = '0';
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          sheet.style.transform = 'translateY(0)';
          overlay.style.transition = 'opacity .3s';
          overlay.style.opacity = '1';
        });
      });

      // Auto-dismiss after 8s
      clearTimeout(sheetTimer);
      sheetTimer = setTimeout(dismissSheet, 8000);
    }

    // Dismiss handlers
    closeBtn && closeBtn.addEventListener('click', dismissSheet);
    nothanksBtn && nothanksBtn.addEventListener('click', dismissSheet);
    overlay.addEventListener('click', dismissSheet);

    // Listen for cart change (fires after successful add)
    document.addEventListener('theme:cart:change', function(e) {
      var cart = e.detail && e.detail.cart;
      if (!cart) return;
      var newCount = cart.item_count || 0;
      if (lastCartCount >= 0 && newCount > lastCartCount) {
        // Item was just added — show suggestion
        fetch('/products/' + suggestHandle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(product) {
            if (product.available) showSheet(product, cart.items || []);
          })
          .catch(function() {});
      }
      lastCartCount = newCount;
    });

    // Initialize cart count
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { lastCartCount = cart.item_count || 0; })
      .catch(function() { lastCartCount = 0; });
  })();

  // ── Pre-checkout interstitial ─────────────────────────────────────────────
  // Intercepts cart form submit (checkout button only). Buttons stay type="submit"
  // so checkout always works even if this JS errors out entirely.
  (function() {
    var PCI_PRODUCTS = ['stoic-socks', 'stoic-wrist-wraps'];
    var modalActive = false;
    var proceedTimer = null;
    var cached = null; // { product, handle }

    function findSuggestion(inCart, idx) {
      if (idx >= PCI_PRODUCTS.length) { cached = null; return Promise.resolve(); }
      var handle = PCI_PRODUCTS[idx];
      if (inCart.indexOf(handle) !== -1) return findSuggestion(inCart, idx + 1);
      return fetch('/products/' + handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(prod) {
          if (!prod.available || !prod.variants.filter(function(v){ return v.available; }).length) {
            return findSuggestion(inCart, idx + 1);
          }
          cached = { product: prod, handle: handle };
        })
        .catch(function() { return findSuggestion(inCart, idx + 1); });
    }

    function prefetch() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var inCart = (cart.items || []).map(function(i) { return i.handle; });
          return findSuggestion(inCart, 0);
        })
        .catch(function() { cached = null; });
    }

    prefetch();
    document.addEventListener('theme:cart:change', prefetch);
    document.addEventListener('theme:cart:reload', prefetch);

    function goCheckout() {
      clearInterval(proceedTimer);
      proceedTimer = null;
      var el = document.getElementById('stoic-pci-overlay');
      if (el) el.remove();
      modalActive = false;
      window.location.href = '/checkout';
    }

    // Track whether the checkout button (not update) triggered the submit
    var checkoutBtnClicked = false;
    document.addEventListener('click', function(e) {
      checkoutBtnClicked = !!e.target.closest('[name="checkout"]');
    }, true);

    // Intercept form submit in capture phase — only when checkout clicked + suggestion exists
    document.addEventListener('submit', function(e) {
      if (!checkoutBtnClicked || !cached || modalActive) return;
      checkoutBtnClicked = false;
      e.preventDefault();
      showModal(cached.product, cached.handle);
    }, true);

    // Inject keyframes once so animations work on cart/drawer pages
    (function() {
      if (document.getElementById('stoic-pci-css')) return;
      var s = document.createElement('style');
      s.id = 'stoic-pci-css';
      s.textContent = '@keyframes stoicFadeIn{from{opacity:0}to{opacity:1}}@keyframes stoicSlideUp{from{transform:translateY(100%)}to{transform:translateY(0)}}';
      document.head.appendChild(s);
    })();

    // Per-product config.
    // lockStyle: exact option1 value to lock to (check your Shopify variant names).
    //            null = use first available style.
    // stars/reviews: TODO verify against your actual review app numbers.
    var PCI_META = {
      'stoic-socks': {
        tagline: 'Deadlift without the shin scrape.',
        stars: 4.8,
        reviews: 312,
        lockStyle: 'Knee' // Shopify option1 value for knee-height style
      },
      'stoic-wrist-wraps': {
        tagline: 'Heavy sets take a toll on your wrists over time. These keep yours healthy.',
        stars: 4.9,
        reviews: 189,
        lockStyle: null
      }
    };

    // options[] in the AJAX product API can be either strings or {name,values} objects
    function optName(opt) {
      if (!opt) return '';
      return typeof opt === 'object' ? (opt.name || '') : opt;
    }

    function starsHTML(rating, count) {
      if (!rating || !count) return '';
      return '<div style="display:flex;align-items:center;gap:6px;margin-bottom:8px;">'
        + '<span style="color:#f5a51d;font-size:.95rem;letter-spacing:.05em;">&#9733;&#9733;&#9733;&#9733;&#9733;</span>'
        + '<span style="font-size:.8rem;color:rgba(0,0,0,.5);">'
        + rating.toFixed(1) + ' &middot; ' + count.toLocaleString() + ' reviews'
        + '</span></div>';
    }

    function showModal(product, handle) {
      if (modalActive) { goCheckout(); return; }
      modalActive = true;

      var allVariants = product.variants;
      var availableVariants = allVariants.filter(function(v) { return v.available; });
      if (!availableVariants.length) { goCheckout(); return; }

      var fmt = function(cents) {
        return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      };

      var meta = PCI_META[handle] || {};

      // Determine which variants to surface as the size picker.
      // For multi-option products (e.g. Style + Size):
      //   - use meta.lockStyle to pin to the right style (e.g. Knee High)
      //   - fall back to first available option1 if lockStyle not found in this product
      // This means we only ever show size pills, never a "go to product page" dead-end.
      var displayVariants = allVariants;
      var sizeLabel = optName(product.options[0]) || 'Size';

      if (product.options.length > 1) {
        var desiredStyle = meta.lockStyle;
        var styleMatch = desiredStyle
          ? allVariants.filter(function(v) { return v.option1 === desiredStyle; })
          : [];
        var lockedOpt1 = (styleMatch.length && styleMatch.filter(function(v){return v.available;}).length)
          ? desiredStyle
          : availableVariants[0].option1;
        displayVariants = allVariants.filter(function(v) { return v.option1 === lockedOpt1; });
        sizeLabel = optName(product.options[1]) || 'Size';
      }

      var first = displayVariants.filter(function(v) { return v.available; })[0] || availableVariants[0];
      var price = fmt(first.price);

      // Prefer variant-specific image (e.g. knee-high has its own photo)
      var img = (first.featured_image && first.featured_image.src)
        ? first.featured_image.src
        : (typeof product.featured_image === 'string' ? product.featured_image : '')
          || (product.images && product.images[0] ? product.images[0] : '');

      var shortName = product.title.split(' ').slice(0, 3).join(' ');

      // Size pills — always inline, never a link off the modal
      var pillsHTML = '';
      if (displayVariants.length > 1) {
        pillsHTML = '<div style="margin-bottom:18px;">'
          + '<p style="margin:0 0 8px;font-size:.7rem;font-weight:700;letter-spacing:.08em;'
          + 'text-transform:uppercase;color:rgba(0,0,0,.4);">' + sizeLabel + '</p>'
          + '<div style="display:flex;flex-wrap:wrap;gap:6px;">';
        displayVariants.forEach(function(v) {
          var sel = v.id === first.id;
          var avail = v.available;
          var vp = fmt(v.price);
          var label = product.options.length > 1 ? v.option2 : v.title;
          pillsHTML += '<button data-pci-pill data-vid="' + v.id + '" data-vprice="' + vp + '"'
            + (!avail ? ' disabled' : '')
            + ' style="padding:10px 18px;border:2px solid ' + (sel ? '#111' : 'rgba(0,0,0,.15)') + ';'
            + 'border-radius:5px;background:' + (sel ? '#111' : '#fff') + ';color:' + (sel ? '#fff' : '#111') + ';'
            + 'font-size:.88rem;font-weight:' + (sel ? '700' : '500') + ';cursor:pointer;'
            + (!avail ? 'opacity:.3;cursor:default;text-decoration:line-through;' : '') + '">'
            + label + '</button>';
        });
        pillsHTML += '</div></div>';
      }

      var overlay = document.createElement('div');
      overlay.id = 'stoic-pci-overlay';
      overlay.style.cssText = 'position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.6);'
        + 'display:flex;align-items:flex-end;justify-content:center;animation:stoicFadeIn .2s ease;';

      overlay.innerHTML =
        '<div style="width:100%;max-width:560px;background:#fff;border-radius:20px 20px 0 0;'
        + 'padding-bottom:env(safe-area-inset-bottom,0);animation:stoicSlideUp .3s cubic-bezier(.32,.72,0,1);">'

          // Drag handle
          + '<div style="display:flex;justify-content:center;padding:12px 0 4px;">'
            + '<div style="width:36px;height:4px;border-radius:2px;background:rgba(0,0,0,.1);"></div>'
          + '</div>'

          // Product card
          + '<div style="display:flex;gap:16px;padding:16px 20px;align-items:flex-start;">'
            + '<img src="' + img + '" width="130" height="130" loading="eager"'
            + ' alt="' + product.title.replace(/"/g,'&quot;') + '"'
            + ' style="width:130px;height:130px;object-fit:cover;border-radius:10px;flex-shrink:0;display:block;">'
            + '<div style="flex:1;min-width:0;">'
              + '<p style="margin:0 0 5px;font-size:.63rem;font-weight:700;letter-spacing:.1em;'
              + 'text-transform:uppercase;color:rgba(0,0,0,.3);">Lifters also grab</p>'
              + '<p style="margin:0 0 5px;font-size:1.08rem;font-weight:800;line-height:1.15;color:#111;">'
              + product.title + '</p>'
              + starsHTML(meta.stars, meta.reviews)
              + (meta.tagline
                ? '<p style="margin:0 0 10px;font-size:.83rem;line-height:1.5;color:rgba(0,0,0,.5);">'
                  + meta.tagline + '</p>'
                : '')
              + '<p style="margin:0;font-size:1.2rem;font-weight:800;color:#111;" id="stoic-pci-price-display">'
              + price + '</p>'
            + '</div>'
          + '</div>'

          // Divider
          + '<div style="height:1px;background:rgba(0,0,0,.07);margin:0 20px;"></div>'

          // Size picker + CTA
          + '<div style="padding:18px 20px 16px;">'
            + pillsHTML
            + '<button id="stoic-pci-add" data-vid="' + first.id + '"'
            + ' style="display:block;width:100%;background:#c44f00;color:#fff;border:none;font-weight:800;'
            + 'font-size:1rem;letter-spacing:.04em;text-transform:uppercase;padding:18px;border-radius:6px;cursor:pointer;">'
            + 'Add ' + shortName + ' \u2014 <span id="stoic-pci-price">' + price + '</span>'
            + '</button>'
            + '<p style="margin:8px 0 0;text-align:center;font-size:.78rem;color:rgba(0,0,0,.4);">'
            + '&#10003; Shipped with your order &mdash; no separate checkout'
            + '</p>'
            + '<button id="stoic-pci-skip"'
            + ' style="display:block;width:100%;margin-top:10px;background:none;border:none;'
            + 'padding:12px;cursor:pointer;font-size:.9rem;font-weight:600;color:#444;text-decoration:underline;text-underline-offset:3px;text-align:center;">'
            + 'No thanks \u2014 continue to checkout \u2192</button>'
          + '</div>'
        + '</div>';

      document.body.appendChild(overlay);

      // Pill selection — update variant ID and both price displays
      overlay.querySelectorAll('[data-pci-pill]').forEach(function(pill) {
        pill.addEventListener('click', function() {
          overlay.querySelectorAll('[data-pci-pill]').forEach(function(p) {
            p.style.background = '#fff'; p.style.color = '#111';
            p.style.borderColor = 'rgba(0,0,0,.15)'; p.style.fontWeight = '500';
          });
          pill.style.background = '#111'; pill.style.color = '#fff';
          pill.style.borderColor = '#111'; pill.style.fontWeight = '700';
          var vp = pill.getAttribute('data-vprice');
          var btn = document.getElementById('stoic-pci-add');
          if (btn) btn.setAttribute('data-vid', pill.getAttribute('data-vid'));
          var ip = document.getElementById('stoic-pci-price');
          if (ip) ip.textContent = vp;
          var cp = document.getElementById('stoic-pci-price-display');
          if (cp) cp.textContent = vp;
        });
      });

      var addBtn = document.getElementById('stoic-pci-add');
      if (addBtn) {
        addBtn.addEventListener('click', function() {
          var vid = addBtn.getAttribute('data-vid');
          if (!vid) { goCheckout(); return; }
          addBtn.disabled = true; addBtn.style.opacity = '.7'; addBtn.textContent = 'Adding\u2026';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'id=' + vid + '&quantity=1'
          }).then(goCheckout).catch(goCheckout);
        });
      }

      document.getElementById('stoic-pci-skip').addEventListener('click', goCheckout);
      overlay.addEventListener('click', function(e) { if (e.target === overlay) goCheckout(); });
      proceedTimer = setTimeout(goCheckout, 25000);
    }
  })();

  // ── Default size selection ────────────────────────────────────────────────
  // Selects M (or next in priority) instead of always landing on XXS/XS.
  // Skips if ?variant= is already in the URL (direct variant link).
  // Pipeline uses theme:popout:click internally — we dispatch it directly
  // to avoid issues with clicking hidden dropdown list items.
  (function() {
    if (new URLSearchParams(window.location.search).has('variant')) return;
    if (!document.querySelector('[data-section-type="product"]')) return;

    function selectPreferredSize() {
      document.querySelectorAll('[data-option-position][data-select-label]').forEach(function(wrapper) {
        if (!(wrapper.getAttribute('data-select-label') || '').toLowerCase().includes('size')) return;

        // Pipeline popout-select (dropdown) — dispatch theme:popout:click directly
        var popoutOpts = wrapper.querySelectorAll('[data-popout-option][data-value]');
        if (popoutOpts.length) {
          var targetIdx = Math.floor((popoutOpts.length - 1) / 2);
          var current = wrapper.querySelector('[data-popout-option][aria-current="true"]');
          var currentIdx = current ? Array.prototype.indexOf.call(popoutOpts, current) : -1;
          if (currentIdx !== targetIdx) {
            popoutOpts[targetIdx].dispatchEvent(new CustomEvent('theme:popout:click', {
              cancelable: true, bubbles: true, detail: { preventTrigger: false }
            }));
          }
          return;
        }

        // Radio button mode (some products use button-style variants)
        var radios = wrapper.querySelectorAll('input[type="radio"]');
        if (radios.length) {
          var targetIdx = Math.floor((radios.length - 1) / 2);
          if (!radios[targetIdx].checked) radios[targetIdx].click();
        }
      });
    }

    // customElements.whenDefined resolves once Pipeline's popout-select is
    // registered AND all existing elements are upgraded (connectedCallback done).
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('popout-select').then(selectPreferredSize);
    } else {
      document.addEventListener('DOMContentLoaded', function() { setTimeout(selectPreferredSize, 300); });
    }
  })();

  // ── Judge.me preview badge ────────────────────────────────────────────────
  // Judge.me renders the badge server-side with display:none and empty star
  // spans (styled via their CSS). In app-block mode without their embed,
  // their loader skips the badge. We unhide it and inject star CSS directly.
  (function() {
    var jmStarStyle = document.createElement('style');
    jmStarStyle.textContent =
      '.jdgm-prev-badge{display:flex;align-items:center;gap:6px;margin-bottom:4px}' +
      '.jdgm-prev-badge__stars{color:#f5a623;font-size:14px;letter-spacing:1px;cursor:pointer}' +
      '.jdgm-star::before{content:"\\2605"}' +
      '.jdgm--off::before{color:#ddd}' +
      '.jdgm-prev-badge__text{font-size:13px;color:#666}';
    document.head.appendChild(jmStarStyle);

    function showJmBadges() {
      document.querySelectorAll('.jdgm-prev-badge[data-number-of-reviews]').forEach(function(el) {
        var count = parseInt(el.getAttribute('data-number-of-reviews') || '0', 10);
        if (count > 0) el.style.removeProperty('display');
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showJmBadges);
    } else {
      showJmBadges();
    }
  })();

  // Color picker (siblings block) needs breathing room above the size options on mobile
  (function() {
    var sibStyle = document.createElement('style');
    sibStyle.textContent = '.product__block__siblings { margin-top: 16px; }';
    document.head.appendChild(sibStyle);
  })();

})();
